module.exports = __webpack_public_path__ + "img/room-popularity-award_zh.c3bf3fdf.png";